import { tariffPlan } from 'utils/api/models/utils/tariffPlan';
import { SingleCustomerProduct } from './singleCustomerProduct';
import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { namaCommitment } from 'utils/api/models/utils/namaCommitment';
import { AccountType } from 'utils/api/models/accounts/accountType';
import { tryAndBuyProduct } from 'utils/api/models/utils/tryAndBuyProduct';
import { corpFbbCommitment } from 'utils/api/models/utils/corpFbbCommitment';

export interface ResourceInfo {
	serialNo: string;
	startDate: string;
}

export type CustomerProducts = {
	_products: any;
	products: SingleCustomerProduct[];
	resourceInfo: ResourceInfo;
	tariffPlan: (accountType: AccountType | undefined) => undefined | SingleCustomerProduct;
	tryAndBuyProduct: undefined | SingleCustomerProduct;
	namaCommitment: undefined | SingleCustomerProduct;
	corpFbbCommitment: undefined | SingleCustomerProduct;
};

const model: types.models.InputModel = {
	_products: ['response.getCustomerProductsResponse.products', []],
	products: (model: CustomerProducts) =>
		model._products.map((singleCustomerProduct: any) =>
			modelsResolver(singleCustomerProduct, 'singleCustomerProduct')
		),
	resourceInfo: 'response.getCustomerProductsResponse.resourceInfo',
	tariffPlan: function(model: CustomerProducts) {
		return (accountType: AccountType) => tariffPlan(model.products, 'group', accountType);
	},
	namaCommitment: function(model: CustomerProducts) {
		return namaCommitment(model.products);
	},
	tryAndBuyProduct: function(model: CustomerProducts) {
		return tryAndBuyProduct(model.products);
	},
	corpFbbCommitment: function(model: CustomerProducts) {
		return corpFbbCommitment(model.products);
	},
};

export default model;
